[
  {
    "code": "FJ-C",
    "name": "Central"
  },
  {
    "code": "FJ-E",
    "name": "Eastern"
  },
  {
    "code": "FJ-N",
    "name": "Northern"
  },
  {
    "code": "FJ-R",
    "name": "Rotuma"
  },
  {
    "code": "FJ-W",
    "name": "Western"
  }
]